// src/api/subscriptionApi.js
import { createAuthenticatedClient } from "./http";
import config from "../config";

const api = createAuthenticatedClient({
    baseURL: `${config.SERVER_URL}/api/subscription`,
});

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

/** Current plan + this user's subscription state. */
export async function fetchSubscription() {
    const { data } = await api.get("/");
    return data;
}

/**
 * Check a promo code without committing to it.
 * Resolves to { valid: false, error } for bad codes rather than throwing —
 * an unrecognized code is an expected outcome, not a request failure.
 */
export async function validatePromoCode(code) {
    const { data } = await api.post("/validate-code", { code });
    return data;
}

/** Start Checkout. Returns the Stripe-hosted URL to redirect to. */
export async function createCheckoutSession(code = null) {
    const { data } = await api.post("/checkout", code ? { code } : {});
    return data;
}

/** Open the Stripe billing portal (update card, view invoices, cancel). */
export async function createPortalSession() {
    const { data } = await api.post("/portal");
    return data;
}

/** Sync state straight after the Checkout redirect, ahead of the webhook. */
export async function confirmCheckout(sessionId) {
    const { data } = await api.get("/confirm", { params: { session_id: sessionId } });
    return data;
}
